import Modal from '@mui/material/Modal'
import { Button } from '@zuto/atoms'
import styled from 'styled-components'
import { LargeAlert } from '@zuto/icons'
import React, { useState } from 'react'
import { textStyle } from '@zuto/utilities'
import {
  color, compose
} from 'styled-system'
import Box from '@zuto/core/src/box'

const StyledDialog = styled.div`
  outline: none;
  margin: auto 64px;
  border-radius: 12px;
  background: #FFFFFF;
  box-shadow: 0px 5px 28px rgba(166, 175, 185, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 16px;
  position: fixed;
  top: 50%;
  left: calc(50% - 64px);
  transform: translate(-50%, -50%);
  max-width: 364px;
`

const StyledButton = styled(Button)`
justify-content: center;
min-width: 221px;
`

const StyledBox = styled(Box)`
margin-bottom: 24px;
justify-content: center;
`

const StyledHeading = styled(Box)`
margin: 16px;
justify-content: center;
${(props) => compose(color, textStyle(props))({
    ...props,
    textStyle: 'body.regular.medium',
    color: 'neutrals.4'
  })}
`

interface ErrorMessageProps {
  titleText?: string
  ctaText?: string
  children: React.ReactNode
  onClick?: () => void
}

const ErrorModal = ({
  titleText, ctaText, children, onClick
}: ErrorMessageProps) => {
  // Shown when mounted. Escape closes it, as does the CTA when there is no onClick.
  const [visible, setVisible] = useState(true)

  return (
    <Modal
      open={visible}
      // a click outside does not close it
      onClose={(_event, reason) => { if (reason === 'escapeKeyDown') setVisible(false) }}
      disableAutoFocus
    >
      <StyledDialog
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        data-testid="error-modal"
        aria-labelledby="error-title"
        aria-describedby="error-text"
      >
        <LargeAlert />
        <StyledHeading id="error-title">
          {titleText || 'Oh, snap!'}
        </StyledHeading>
        <StyledBox id="error-text" color="neutrals.3" textStyle="body.current.regular">
          {children}
        </StyledBox>
        {ctaText && (
          <StyledButton
            // focus starts on the CTA; the dialog content only exists once the portal has mounted
            ref={(button: HTMLButtonElement | null) => button?.focus()}
            data-testid="error-cta"
            variant="secondary"
            onClick={() => {
              if (onClick) {
                onClick()
              } else {
                setVisible(false)
              }
            }}
          >
          {ctaText || 'Enter address'}
          </StyledButton>
        )}
      </StyledDialog>
    </Modal>
  )
}

export default ErrorModal
